export const GET_USER_ROLE = 'providers/AccessManagementUserRole/GET_USER_ROLE';
export const EDIT_USER_ROLE = 'providers/AccessManagementUserRole/EDIT_USER_ROLE';
